import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "tokens"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './Navbar.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var BaseNavbar = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsx(views.Wrapper, _objectSpread(_objectSpread(_objectSpread({}, tokens), rest), {}, {
    ref: ref,
    children: children
  }));
});
var Navbar = withDesignTokens(BaseNavbar, function (_props, theme) {
  return {
    backgroundColor: theme.palette.neutrals.white[100]
  };
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme, _ref2) {
    var _ref2$isMenuOpen = _ref2.isMenuOpen,
        isMenuOpen = _ref2$isMenuOpen === void 0 ? true : _ref2$isMenuOpen;

    if (isMenuOpen) {
      return {
        backgroundColor: theme.palette.neutrals.white[100]
      };
    }

    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight() {
    return {};
  },
  twilioDark: function twilioDark(theme) {
    return {
      backgroundColor: theme.palette.twilio.gray[100]
    };
  }
});
export default Navbar;